import React from 'react'

export default ({ message }) => (
    <div className="section">
        <div className="container has-text-centered">
            <h1 className="title">{message}</h1>
        </div>
    </div>
)
